const timeout = (ms: number) => new Promise((resolve) => setTimeout(() => resolve(true), ms));

export default timeout;
